export function throttle<Params extends unknown[]>(
	func: (...args: Params) => unknown,
	delay: number,
): (...args: Params) => void {
	let timerFlag = false;

	return (...args: Params) => {
		if (!timerFlag) {
			func(...args);
			timerFlag = true;
			setTimeout(() => {
				timerFlag = false;
			}, delay);
		}
	};
}
